const itemCount = {
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '17.5px',
  letterSpacing: '2.1px'
}

const loyaltyProductsGrid = {
  itemCount
}

export default loyaltyProductsGrid
